import React from "react";
import tw from "twin.macro";
//import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithInput.js";
import Features from "components/features/ThreeColWithSideImage.js";
//import MainFeature from "components/features/TwoColWithButton.js";
import MainFeature2 from "components/features/TwoColWithTwoHorizontalFeaturesAndButton.js";
import FeatureWithSteps from "components/features/TwoColWithSteps.js";
import Pricing from "components/pricing/ThreePlans.js";
//import Testimonial from "components/testimonials/TwoColumnWithImageAndRating.js";
import FAQ from "components/faqs/SingleCol.js";
import GetStarted from "components/cta/GetStarted";
import Footer from "components/footers/FiveColumnWithBackground.js";
//import heroScreenshotImageSrc from "images/hero-screenshot-1.png";
import macHeroScreenshotImageSrc from "images/Hero-2.svg";
import prototypeIllustrationImageSrc from "images/prototype-illustration.svg";
import { ReactComponent as BriefcaseIcon } from "feather-icons/dist/icons/briefcase.svg";
import { ReactComponent as MoneyIcon } from "feather-icons/dist/icons/dollar-sign.svg";

export default () => {
  const Subheading = tw.span`uppercase tracking-widest font-bold text-primary-500`;
  const HighlightedText = tw.span`text-primary-500`;

  return (
    <AnimationRevealPage>
      <section id="header">
        <Hero roundedHeaderButton={true} />
      </section>
      <section id="how-it-works" className="section">
        <FeatureWithSteps
          subheading={<Subheading>STEPS</Subheading>}
          heading={
            <>
              Easy to <HighlightedText>Get Started</HighlightedText>
            </>
          }
          textOnLeft={false}
          imageSrc={macHeroScreenshotImageSrc}
          imageDecoratorBlob={true}
          decoratorBlobCss={tw`xl:w-40 xl:h-40 opacity-15 -translate-x-1/2 left-1/2`}
        />
      </section>
      <section id="features" className="section">
        <Features
          subheading={<Subheading></Subheading>}
          heading={
            <>
              Effortless KYC Verification with{" "}
              <HighlightedText>WhatsApp </HighlightedText> Integration
            </>
          }
        />
      </section>
      <section id="main-feature-2" className="section">
        <MainFeature2
          subheading={<Subheading>VERSATILE</Subheading>}
          heading={
            <>
              Unlock a Spectrum of Verification{" "}
              <HighlightedText>Checks</HighlightedText>
            </>
          }
          description={
            <>
              Unlock a wide range of verification checks with Cheker's versatile
              data verification toolkit. From KYC to fraud detection and beyond,
              tailor your checks to fit your needs and protect your business.
            </>
          }
          imageSrc={prototypeIllustrationImageSrc}
          primaryButtonUrl="https://calendly.com/xavier-rocabado/discovery-call"
          primaryButtonText="Start Now"
          showDecoratorBlob={false}
          features={[
            {
              Icon: MoneyIcon,
              title: "KYC & ID Validation",
              description:
                "Effortlessly confirm the identity of your customers with our KYC and ID validation checks.",
              iconContainerCss: tw`bg-green-300 text-green-800`,
            },
            {
              Icon: BriefcaseIcon,
              title: "Fraud noting & more",
              description:
                "Detect fraud numbers, emails, perform ID OCR, and validate proof of address.",
              iconContainerCss: tw`bg-red-300 text-red-800`,
            },
          ]}
        />
      </section>
      <section id="pricing" className="section">
        <Pricing
          subheading={<Subheading>PRICING</Subheading>}
          heading={
            <>
              Simple & Flexible <HighlightedText>Plans</HighlightedText>
            </>
          }
          description={<>Secure payments integrated through Stripe.</>}
          primaryButtonText={<>Get Started</>}
          plans={[
            {
              name: "Basic",
              price: "$49",
              duration: "Monthly",
              mainFeature: "For Start Ups",
              features: [
                "1 WABA linked",
                "500 Verifications",
                "1,000 Chat Attempts",
                "Pre-established Templates",
                "$0.15 per additional verification",
              ],
            },
            {
              name: "Business",
              price: "$99",
              duration: "Monthly",
              mainFeature: "For Scale Ups",
              features: [
                "1 WABA linked",
                "1,000 Verifications",
                "1,500 Chat Attempts",
                "Customizable Templates",
                "$0.125 per additional verification",
              ],
              featured: true,
            },
            {
              name: "Enterprise",
              price: "$199",
              duration: "Monthly",
              mainFeature: "For Large Companies",
              features: [
                "3 WABA linked",
                "2,000 Verifications",
                "2,500 Chat Attempts",
                "Customizable Templates",
                "$0.10 per additional verification",
              ],
            },
          ]}
        />
      </section>
      <section id="FAQs" className="section">
        <FAQ
          subheading={<Subheading></Subheading>}
          heading={
            <>
              You have <HighlightedText>Questions ?</HighlightedText>
            </>
          }
          faqs={[
            {
              question: "Why WhatsApp for KYC verification ?",
              answer:
                "WhatsApp is one of the most popular messaging platforms, making it convenient for customers to interact and verify their identity. It's also highly accessible and user-friendly, improving the customer experience.",
            },
            {
              question: "Is my customer data secure with Cheker ?",
              answer:
                "Cheker takes data security seriously, and while we're a startup, we are committed to maintaining a safe environment for your customer data. We implement standard security measures and ensure compliance with industry regulations to safeguard your information. While we may not have the extensive resources of larger companies, we do our best to protect your data within the bounds of our startup capacity.",
            },
            {
              question: "Do I need technical expertise to use Cheker ?",
              answer:
                "No, you don't need extensive technical skills. Cheker is designed for user-friendliness, and our onboarding process is straightforward. However, our support team is always available to assist you if you have any questions or encounter issues during setup.",
            },
            {
              question:
                "How do I integrate Cheker with my business processes ?",
              answer:
                "Integrating Cheker is simple. You can link your WhatsApp Business Account and connect it to Cheker. Our platform seamlessly integrates with your existing systems. Our support team can assist you during the setup process.",
            },
            {
              question:
                "Who provides the KYC service, and is it compliant with regulations ?",
              answer:
                "Cheker offers the KYC service, and we prioritize compliance with industry regulations. Our system is designed to meet KYC compliance requirements, and we continually update our practices to align with changing regulations. We ensure your KYC processes are compliant and secure.",
            },
          ]}
        />
      </section>
      <section id="get-started" className="section">
        <GetStarted
          text="Talk to our CEO!"
          primaryLinkUrl="https://calendly.com/xavier-rocabado/discovery-call"
          secondaryLinkUrl="mailto:xavi.rocabado@gmail.com"
        />
      </section>
      <Footer />
    </AnimationRevealPage>
  );
};
